<template>
	<button @click="handleClick" class="action-btn" :class="{ disabled: disabled }">
		<div class="button-content">
			<div v-if="iconSrc" class="icon-container" :style="{ backgroundColor: getIconColor(iconSrc) }">
				<InlineSvg :src="iconSrc" class="action-inline-svg" />
			</div>
			<span class="button-text">{{ text }}</span>
		</div>
	</button>
</template>

<script>
	export default {
		name: 'ActionButton',
		props: {
			text: {
				type: String,
				required: true,
			},
			iconSrc: {
				type: String,
				default: null,
			},
			disabled: {
				type: Boolean,
				default: false,
			},
		},
		methods: {
			handleClick() {
				if (!this.disabled) {
					this.$emit('click')
				}
			},
			getIconColor(iconSrc) {
				const colorMap = {
					'images/icons-2025/ai-document.svg': '#72B8FF',
					'images/icons-2025/ai-design.svg': '#A372FF',
					'images/icons-2025/ai-generate-product.svg': '#7472FF',
					'images/icons-2025/ai-inform.svg': '#FFAD72',
				}
				return colorMap[iconSrc] || colorMap.default
			},
		},
	}
</script>

<style lang="scss" scoped>
	.action-btn {
		background: #ebebff;
		padding: 8px 12px 8px 8px;
		border: none;
		border-radius: 12px;
		cursor: pointer;
		transition: all 0.3s ease;
		width: max-content;
		animation: fadeIn 0.5s ease-out forwards;
	}

	.action-btn:hover:not(.disabled) {
		background: #d8d8ff;
		transform: translateY(-1px);
	}

	.action-btn.disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}

	.button-content {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.button-text {
		color: #131f60;
		font-size: 15px;
		font-family: Inter, sans-serif;
		font-weight: 500;
		line-height: 15px;
		word-wrap: break-word;
	}

	.icon-container {
		width: 22px;
		height: 22px;
		border-radius: 7.5px;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: all 0.3s ease;
	}

	.action-inline-svg::v-deep {
		width: 18px;
		height: 18px;
		display: flex;
		align-items: center;
		justify-content: center;
		path {
			fill: white;
		}
	}

	@keyframes fadeIn {
		from {
			opacity: 0;
			transform: translateY(20px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}
</style>
